import { useDispatch, useSelector } from "react-redux";
import { VDOARCHIVE } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import {
  Container,
  Card,
  Grid,
  Typography,
  Box,
  Pagination,
} from "@mui/material";
import {
  COMPANY,
  PROJECT,
  TIMELAPSE,
  VIDEOZIP,
  VIDEOZIPALL,
} from "../../services/actions";
import VDOForm from "./VDOForm";
import ProgressBar from "../extra/ProgressBar";
import InfoCard2 from "../extra/InfoCard2";
import logoPng from "./videologo.png";
import Breadcrumb from "../../extra2/Breadcrumb";

const formattedDate = (isoString) => {
  try {
    if (!isoString) return { date: '', day: '' };
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return { date: '', day: '' };
    const fd = date.toISOString().split("T")[0]; // "2025-05-23"
    const day = date.getUTCDate(); // returns 23
    return { date: fd, day: day };
  } catch (err) {
    return { date: '', day: '' };
  }
};
export default function VideoArchive() {
  const documentStyle = getComputedStyle(document.documentElement);
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = React.useState(false);
  let projectState = useSelector((state) => state?.projectState);
  let companyState = useSelector((state) => state?.companyState);
  let timelapseState = useSelector((state) => state?.timelapseState);
  let videozipallState = useSelector((state) => state?.videozipallState);
  let videozipState = useSelector((state) => state?.videozipState);
  let user = useSelector((state) => state?.loginState?.auth);
  const companies = React.useMemo(() => {
    if (user?.main_role === "Company") {
      return user?.companies || [];
    }
    return Array.isArray(companyState?.data?.results) ? companyState.data.results : [];
  }, [user?.main_role, user?.companies, companyState?.data?.results]);

  const [defV, setDefV] = React.useState({});
  const [page, setPage] = React.useState(1); // current page (1-indexed for MUI Pagination)
  const pageSize = 20; // number of items per page

  const fetchVideoArchives = React.useCallback((p = 1) => {
    const pageNum = Number(p) || 1;
    const url = pageNum <= 1 ? `video-zip/0/` : `video-zip/?page=${pageNum}`;
    dispatch({ type: `${VIDEOZIPALL}_GET`, payload: url });
  }, [dispatch]);

  React.useEffect(() => {
    if (user?.main_role !== "Company") {
      dispatch({ type: `${COMPANY}_GET`, payload: 0 });
    }
  }, [user?.main_role, dispatch]);

  React.useEffect(() => {
    fetchVideoArchives(page);
  }, [page, fetchVideoArchives]);

  React.useEffect(() => {
    setLoader(false);
  }, [videozipallState?.data]);

  const handleFormChange = React.useCallback((action, value) => {
    if (!value) return;
    if (action === "project") {
      dispatch({
        type: `${TIMELAPSE}_GET`,
        payload: `timelapse/0/?filter_by={"project":"${value}"}`,
      });
    } else if (action === "company") {
      dispatch({
        type: `${PROJECT}_GET`,
        payload: `project/0/?filter_by={"company":"${value}"}`,
      });
    }
  }, [dispatch]);

  const handleFormOpen = () => { };
  const handleDelete = (id) => {
    dispatch({ type: `${VIDEOZIP}_DELETE`, payload: id });
  };

  return (
    <>
      <Container maxWidth="false" className="py-3">
        <Breadcrumb title="Archives" subtitle="Video Archives" />
        <Grid container spacing={2}>
          <Grid size={{ md: 12 }} >
            <Card sx={{ borderRadius: 4, px: 3, py: 2, background: "#ffffff8f", mb: 1, mt: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#2c3e50' }}>
                Video Archives
              </Typography>
              <VDOForm
                companies={companies}
                projects={projectState?.data?.results}
                cameras={timelapseState?.data?.results}
                defaultValues={defV}
                onSubmit={(data) => {
                  setLoader(true);
                  let ACTION = data.id ? `${VIDEOZIP}_PATCH` : `${VIDEOZIP}_POST`;
                  dispatch({ type: ACTION, payload: data });
                }}
                onChange={handleFormChange}
              />
            </Card>
            {loader && <ProgressBar />}
          </Grid>
        </Grid>
        <Grid container spacing={1} sx={{ py: 3 }}>
          {(Array.isArray(videozipallState?.data?.results) ? videozipallState.data.results : []).map((item, index) => {
            const _from = formattedDate(item?.date_from) || { date: '', day: '' };
            const _to = formattedDate(item?.date_to) || { date: '', day: '' };
            const cardData = {
              ...item,
              to_day: _to.day,
              from_day: _from.day,
              date: _from.date ? `${_from.date} - ${_to.date || ''}` : '',
              image: logoPng,
              fname: `${item?.company_name || ''} ${item?.project_name || ''}`.trim()
            };
            return (
              <React.Fragment key={item?.id || index}>
                <Grid size={{ xs: 12, sm: 2, md: 3 }}>
                  <InfoCard2
                    img_type={"company"}
                    keys={[
                      "image",
                      "camera_name",
                      "fname",
                      "date",
                      "From",
                      "from_day",
                      "Up To",
                      "to_day",
                      "Videos",
                      "file_count",
                    ]}
                    data={cardData}
                    onClick={() => {
                      // navigate if needed
                    }}
                    onAction={(action) => {
                      if (action === "Edit") {
                        handleFormOpen(item);
                      } else if (action === "Delete") {
                        handleDelete(item.id);
                      }
                    }}
                  />
                </Grid>
              </React.Fragment>
            );
          })}
        </Grid>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={Math.max(1, Math.ceil((videozipallState?.data?.count || 0) / pageSize))}
            page={Math.max(1, page || 1)}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      </Container>
    </>
  );
}
